import {
    AccountLaneFormFields,
} from 'app/Apps/AccountManagement/AccountLanes/AccountLaneForm/AccountLaneForm.fields'
import {
    TransportModeRoad,
} from 'app/enums/label.enums'
import {
    FieldInCard,
} from 'app/types/form.types'

export default ({
    getAllowedValues,
    disabled,
    showLTL,
    showFTL,
    isStatusPriced,
}: {
    getAllowedValues: (val: Record<string, string>) => Record<string, string>,
    disabled?: boolean,
    showFTL?: boolean,
    showLTL?: boolean,
    isStatusPriced?: boolean,
}): FieldInCard<keyof AccountLaneFormFields>[] => {
    const transportModeRoad = {
        name: 'transportModeRoad',
        labelKey: 'LaneGroupCreateOrDuplicateDto.transportModeRoad',
        componentName: 'EnumSelector',
        allowedValues: getAllowedValues(TransportModeRoad),
        useDropdown: true,
        showInColumns: true,
        required: true,
        disabled: disabled || isStatusPriced,
    } as FieldInCard<keyof AccountLaneFormFields>

    const isFtlPositioningTemperatureControlled = {
        name: 'isFtlPositioningTemperatureControlled',
        labelKey: 'AccountLane.isFtlPositioningTemperatureControlled',
        componentName: 'Checkbox',
        disabled: disabled || isStatusPriced,
    } as FieldInCard<keyof AccountLaneFormFields>

    const isLtlPositioningTemperatureControlled = {
        name: 'isLtlPositioningTemperatureControlled',
        labelKey: 'AccountLane.isLtlPositioningTemperatureControlled',
        componentName: 'Checkbox',
        disabled: disabled || isStatusPriced,
    } as FieldInCard<keyof AccountLaneFormFields>

    let transportModeFields = [transportModeRoad]

    if (showLTL) {
        transportModeFields = [
            ...transportModeFields,
            isLtlPositioningTemperatureControlled,
        ]
    }

    if (showFTL) {
        transportModeFields = [
            ...transportModeFields,
            isFtlPositioningTemperatureControlled,
        ]
    }

    return transportModeFields
}
